'use client';
import { useState } from "react";
import "./Faq.css";
import top from "../../assets/images/plan/down-drop (1).png";
import down from "../../assets/images/plan/down-drop (2).png";



const FaqComponent = ({ faqList }) => {
  const [openIndex, setOpenIndex] = useState(0); 

  const toggleaccordionn = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section1 contanier">
      <div className="faq-container1 ">
        {/* Left column */}
        <div className="faq-right">
          <div className="faq-box">
            <h1>Frequently Asked Questions</h1>
          </div>
        </div>

        {/* Right column */}
        <div className="faq-left">
          {faqList?.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div className="accordionn " key={item?.id} onClick={() => toggleaccordionn(index)}>
                <div className="accordionn-item">

                  <div
                    className={`accordionn-header ${isOpen ? "active" : ""}`}
                    
                  >
                    <h5>{item?.faq_que}</h5>
                    <span>
                      <img
                        src={isOpen ? down : top}
                        alt={isOpen ? "close" : "open"}
                      />
                    </span>
                  </div>

                  <div
                    className={`accordionn-content ${isOpen ? "open" : ""}`}
                    style={{
                      maxHeight: isOpen ? "500px" : "0px",
                    }}
                  >
                    <p>{item?.faq_ans}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqComponent;
